module.exports = __webpack_public_path__ + "files/d09461e773d7a194502246db31c3c1df.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700italic.eot
// module id = 397
// module chunks = 60